<template>
  <div>
    <v-btn class="root-btn" :color="validationState === 'error' ? 'error' : 'primary'"
           outline large @click="openFileChooser" :block="fullWidth">
      <v-img ref="vimg" :src="localPreview || ''" :width="fullWidth ? '100%' : '252px'" height="123px" contain :aspect-ratio="16/9" @error="onLoadPreviewError">

        <div v-show="!localPreview" class="label">
          <v-icon>photo</v-icon>
          <span class="ml-1">{{ label }}</span>
        </div>

        <v-layout v-if="localPreview" slot="placeholder" fill-height align-center justify-center ma-0>
          <v-progress-circular indeterminate color="primary"/>
        </v-layout>

        <input v-show="false" ref="file_input" type="file" accept="image/*" @change="onFileSelected"/>
      </v-img>
    </v-btn>

    <v-tooltip bottom v-if="hint">
      <v-btn flat icon slot="activator">
        <v-icon :color="validationState === 'error' ? 'error' : 'black'">help_outline</v-icon>
      </v-btn>
      <span>{{ hint }}</span>
    </v-tooltip>

    <div class="v-messages error--text mx-2">
      <span v-show="validationState === 'error'">{{ errorBucket[0] }}</span>
    </div>

    <cropper-dialog v-model="cropper.show" :src="cropper.src" @return="onFileCropped" :aspect-ratio="aspectRatio" />

  </div>
</template>

<script>
import Validatable from 'vuetify/es5/mixins/validatable'
import CropperDialog from '@/components/CropperDialog'

export default {
    name: 'ImageInput',
    mixins: [Validatable],
    components: { CropperDialog },
    props: {
        value: [File],
        preview: String,
        label: String,
        hint: String,
        fullWidth: Boolean,
        required: Boolean,
        aspectRatio: {
            type: Number,
            default: NaN
        }
    },
    beforeCreate () {
        this.$delete(this.$options.props, 'rules')
    },
    mounted () {
        this.$nextTick(() => {
            //  Necessario per non mostrare gli errori in console se l'immagine non viene caricata
            if (this.$refs.vimg) this.$refs.vimg.onError = this.onLoadPreviewError
        })
    },
    data: function () {
        return {
            localPreview: this.preview,
            cropper: {
                show: false,
                src: ''
            }
        }
    },
    watch: {
        preview (val) {
            this.localPreview = val
        },
        value (val) {
            if (!val) {
                this.localPreview = this.preview
            }
        }
    },
    computed: {
        internalValue: {
            get () {
                return this.value
            },
            set (val) {
                this.$emit('input', val)
            }
        },
        rules () {
            if (this.required) {
                return [v => (!!v || !!this.localPreview) || this.$t('errori.immagine_richiesta')]
            }
            return []
        }
    },
    methods: {
        openFileChooser () {
            this.$refs.file_input.click()
        },
        onFileSelected () {
            let file = this.$refs.file_input.files[0]
            if (file != null && /\.(jpe?g|png|gif)$/i.test(file.name)) {
                let reader = new FileReader()
                reader.onload = event => {
                    this.cropper.src = event.target.result
                    this.cropper.show = true
                    this.$refs.file_input.value = ''
                }
                reader.readAsDataURL(file)
            }
        },
        onFileCropped (file) {
            this.internalValue = file
            let reader = new FileReader()
            reader.onload = event => {
                this.localPreview = event.target.result
            }
            reader.readAsDataURL(file)
        },
        onLoadPreviewError () {
            this.localPreview = null
        }
    }
}
</script>

<style lang="scss" scoped>
  .root-btn {
    height: 125px !important;
    min-width: 250px !important;
    padding: 0;
    margin: 8px 0 0;

    .label {
      line-height: 123px;

      * {
        vertical-align: middle;
      }
    }
  }

  .v-messages {
    display: block;
    min-height: 1.5em;
  }
</style>
